import { render, staticRenderFns } from "./PagedCards.vue?vue&type=template&id=5e72678e&scoped=true&"
import script from "./PagedCards.vue?vue&type=script&lang=ts&"
export * from "./PagedCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72678e",
  null
  
)

export default component.exports